import {
  AI_TOOL_SELECT_USAGE_NOTE,
  AI_TOOL_WHERE_USAGE_NOTE,
  searchFallbackUsedSchema,
} from '@erikdakoda/ai-tool/findManyAiToolInput';
import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { findAiModelsInputSchema } from './aiModelAiToolInputSchemas';
import { aiModelsToolGroupIcon } from './toolGroupIcon';

export { findAiModelsInputSchema };

export const findAiModelsOutputSchema = z.object({
  results: z
    .array(z.unknown())
    .describe(
      'Rows from findMany. Default minimal mask: id, modelName, integration (provider metadata), label, description. Shape follows caller flat `select` when provided.',
    ),
  count: z.number().int().describe('Number of rows returned (after take).'),
  searchFallbackUsed: searchFallbackUsedSchema,
});

export type FindAiModelsInput = z.infer<typeof findAiModelsInputSchema>;
export type FindAiModelsOutput = z.infer<typeof findAiModelsOutputSchema>;

export const findAiModels: AiTool<undefined, FindAiModelsInput, FindAiModelsOutput> = {
  id: 'findAiModels',

  group: 'ai-models',

  ...aiModelsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description: `List AI models from the global catalog using the structured filter DSL. ${AI_TOOL_WHERE_USAGE_NOTE}

Returns the same minimal default mask as \`searchAiModels\` (id, modelName, integration with provider label/icon/subscription, label, description). ${AI_TOOL_SELECT_USAGE_NOTE}

Use \`searchText\` for indexed text search on modelName, label, integration (substring) and description (full-text / english stem). Default order is integration then modelName. \`searchFallbackUsed\` is true only when typo-tolerant fallback ran.`,
    inputSchema: zodSchema(findAiModelsInputSchema),
    outputSchema: zodSchema(findAiModelsOutputSchema),
  }),
};
